import { RetryBackoffConfig } from 'backoff-rxjs';
import { Logger } from 'oidc-client';

export interface IEnvironmentConfiguration {
  idleTimeThreshold: number;
  production: boolean;
  apiVersion: string;
  version: string;
  siteKey: string;
  gtagPropertyId: string;
  useCallbackFlag?: boolean;
  origin: string;
  mobileCallbackUrl: string;
  authSettings: {
    authLogger: {
      level: number;
      logger: Logger;
    };
    authority: string;
    client_id: string;
    response_type: string;
    scope: string;
    redirect_uri: string;
    post_logout_redirect_uri: string;
    silent_renew_uri: string;
    silent_redirect_uri: string;
    automaticSilentRenew: boolean;
    startCheckSession: boolean;
  };

  featureToggle: {
    openPacks: string,
    selfRegistration: string
  },

  apiConfig: {
    agreementApi: string;
    antiForgeryTokenApi: string;
    apiUrl: string;
    surveyApiUrl: string;
    checkEmailAddressApi: string;
    checkEmailAddressProfileApi: string;
    communicationsApi: string;
    compareReportsApi: string;
    demographicsApi: string;
    downloadApi: string;
    enrichedUserDetailsApi: string;
    hubApi: string;
    impersonationValidationApi: string;
    intercomId: string;
    invitationsApi: string;
    invitationsReminderApi: string;
    journalingApi: string;
    journalingQuadrantApi: string,
    languagesApi: string;
    mostRecentApi: string;
    quadrantsApi: string;
    questionResponseApi: string;
    questionsApi: string;
    participantsGroupsApi: string;
    participantsValidationApi: string;
    previousRespondentsApi: string;
    profileApi: string;
    regenerateApi: string;
    registerApi: string;
    registrationApi: string;
    registrationValidateRegistrationCodeApi: string;
    registrationValidationApi: string;
    reportsApi: string;
    reportsOnlineApi: string;
    reportsRequestTokenApi: string;
    requestPasswordResetApi: string;
    resendRegistrationValidationEmailApi: string;
    resolveTokenApi: string;
    respondentAccept: string;
    respondentDeclineApi: string;
    respondentsApi: string;
    respondentSurvey: string;
    respondentValidationApi: string;
    responseApi: string;
    resultsApi: string;
    setPasswordUrl: string;
    settingsApi: string;
    surveysApi: string;
    systemApi: string;
    userDemographicsApi: string;
    userDetailsApi: string;
    validateRespondentEmailApi: string;
    webClient: string;
    welcomeApi: string;
  };

  retryConfig: RetryBackoffConfig;

}
